<template>
  <div id="errors-list" class="col-span-full">
    <div v-for="error in visibleErrors">
      <ErrorMessage :error="error" @hide="onHide(error)" />
    </div>
  </div>
</template>

<script>
import ErrorMessage from '@/components/errors/errormessage';
import { matchingErrorMessage } from '@/helpers';

export default {
  components: { ErrorMessage },
  props: {
    appErrors: {
      type: Array,
    },
  },
  data() {
    return {
      visibleErrors: [],
    };
  },
  watch: {
    /**
     * Plockar ut unika errors från appErrors
     * och sätter på "visibleErrors"
     */
    appErrors() {
      let uniqueErrors = [];

      this.appErrors.forEach((err) => {
        //err.message = err.message + Math.random()
        const notExisting = !uniqueErrors.some((tm) => {
          return tm.message == err.message;
        });

        // Om felet inte ska visas, då ska det inte visas.........
        const errorConfig = matchingErrorMessage(err);
        if (errorConfig && errorConfig.visible === false) return;

        if (notExisting) uniqueErrors.push(err);
      });

      // this.visibleErrors = uniqueErrors.filter((err) => {
      //   return err.visible;
      // });
      this.visibleErrors = uniqueErrors;
    },
  },

  methods: {
    onHide(error) {
      this.visibleErrors.splice(this.visibleErrors.indexOf(error), 1);
    },
  },
};
</script>
